import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesClientVerificationComponent} from "./sales-client-verification.component";
import {LibraryModule} from "library";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {GeneralModule} from "../general/general.module";
import {SalesClientVerificationStartComponent} from "./start/sales-client-verification-start.component";
import {SalesClientVerificationStatusComponent} from "./status/sales-client-verification-status.component";
import {SalesErrorMessageModule} from "../error-message/sales-error-message.module";



@NgModule({
  declarations: [
    SalesClientVerificationComponent,
    SalesClientVerificationStartComponent,
    SalesClientVerificationStatusComponent,
  ],
  imports: [
    CommonModule,
    LibraryModule,
    PrimengModule,
    GeneralModule,
    SalesErrorMessageModule
  ],
  exports: [
    SalesClientVerificationComponent
  ]
})
export class SalesClientVerificationModule { }
